import { Component, Host, h, Prop, Watch } from '@stencil/core';
import { gettrackmeEventCategory, gettrackmeEventObject } from '../../../utils/tracking-helpers';
import { SelectOption } from '../../forms/sew-combobox/sew-combobox.types';
import { SewComboboxCustomEvent } from '../../../components';

@Component({
    tag: 'sew-ws-downloads',
    styleUrl: 'sew-ws-downloads.scss',
    shadow: true,
})
export class SewWsDownloads {
    @Prop() downloadTitle: string;
    @Prop() downloadTypes: string;
    @Prop() buttonText: string;
    @Prop() linksHeadline: string;
    @Prop() linksText: string;
    @Prop() downloadText: string;
    @Prop() servicesItemLabel: string;
    @Prop() selectedDownloadType: string;
    @Prop() allowSearchInput: boolean;
    @Prop() searchInputLabel = 'Product';
    @Prop() trackingCategory = 'Services';
    @Prop() productInputTitle: string;

    private inputValue: string;
    private hasAlreadyProductId: boolean;
    private selectedDownloadTypeName: string;

    @Watch('downloadTypes')
    checkDownloadTypes(): void {
        if (!this.downloadTypes) return;

        const json = JSON.parse(this.downloadTypes);

        this.selectedDownloadType =
            Array.from(json).filter(
                (type: { name: string; value: string }) => type.value === this.selectedDownloadType
            ).length === 1
                ? this.selectedDownloadType
                : json[0].value;

        Array.from(json).filter(
            (type: { name: string; value: string }) =>
                type.value === this.selectedDownloadType && (this.selectedDownloadTypeName = type.name)
        );
    }

    private checkHasAlreadyProductId(): void {
        if (this.selectedDownloadType && this.selectedDownloadType.includes('&gId=')) {
            this.hasAlreadyProductId = true;
        } else {
            this.hasAlreadyProductId = false;
        }
    }

    private generateLink(): void {
        if (this.inputValue?.length > 0 && !this.hasAlreadyProductId) {
            this.selectedDownloadType = this.selectedDownloadType + '&search=' + this.inputValue;
        }

        location.href = this.selectedDownloadType;
    }

    componentWillLoad() {
        this.checkDownloadTypes();
    }

    render() {
        return (
            <Host>
                <div class="main-content-container">
                    <div class="dropdown-area">
                        {this.downloadTitle && <p class="dropdown-intro">{this.downloadTitle}</p>}
                        <p class="dropdown-text">{this.downloadText}</p>
                        <sew-combobox
                            ws
                            noSearch
                            placeholder=""
                            comboboxId="download-service-combobox"
                            onItemSelected={(selectedItem: SewComboboxCustomEvent<SelectOption>) => {
                                this.selectedDownloadType = selectedItem.detail.value;
                                this.selectedDownloadTypeName = selectedItem.detail.name;
                                this.checkHasAlreadyProductId();
                            }}
                        >
                            <select>
                                {Array.from(JSON.parse(this.downloadTypes)).map(
                                    (option: { name: string; value: string }) => (
                                        <option
                                            value={option.value}
                                            selected={option.value === this.selectedDownloadType}
                                        >
                                            {option.name}
                                        </option>
                                    )
                                )}
                            </select>
                        </sew-combobox>
                    </div>

                    {this.allowSearchInput && !this.hasAlreadyProductId && (
                        <div class="input-area">
                            {this.productInputTitle && (
                                <p class="product-input-title">
                                    {this.productInputTitle.replace('#', this.selectedDownloadTypeName)}
                                </p>
                            )}

                            <sew-input ws>
                                <label htmlFor="download_search_input">{this.searchInputLabel}</label>
                                <input
                                    id="download_search_input"
                                    onInput={e => (this.inputValue = (e.target as HTMLInputElement).value)}
                                    onKeyPress={e => e.key === 'Enter' && this.generateLink()}
                                ></input>
                            </sew-input>
                        </div>
                    )}

                    <sew-ws-button>
                        <button
                            onClick={() => this.generateLink()}
                            data-sew-trackme-event-category={gettrackmeEventCategory(this.trackingCategory)}
                            data-sew-trackme-event-object={gettrackmeEventObject(
                                `${this.trackingCategory}_${this.servicesItemLabel}_${this.buttonText}`
                            )}
                            data-sew-trackme-event-action="Click"
                        >
                            {this.buttonText}
                        </button>
                    </sew-ws-button>

                    <div class="links-area">
                        <div class="links-headline">{this.linksHeadline}</div>
                        <p class="links-text">{this.linksText}</p>
                        <slot></slot>
                    </div>
                </div>
            </Host>
        );
    }
}
